module.exports = __webpack_public_path__ + "dashboard/img/shuffle_d.5911be8e6b59e505a906df71d089280f.svg";